import { ref, watchEffect } from "vue";
import getDate from "@/pages/CreateConnection/utils/dateUtils";

export function useVKCampaign() {
    const selectedVKAccount = ref(null)
    const isVKDataInputRight = ref(false)

    const vkAdsUpload = ref({
        startDate: {
            type: "exact",
            date: null
        },
        endDate: {
            type: "exact",
            date: null
        }
    })

    function setVKUpload(data) {
        vkAdsUpload.value = {
            startDate: data.startDate || { type: "exact", date: null },
            endDate: data.endDate || { type: "exact", date: null }
        }
    }

    function setVKAccount(account) {
        selectedVKAccount.value = account
    }


    watchEffect(() => {
        if (selectedVKAccount.value === null) {
            isVKDataInputRight.value = false
            return
        }
        if (vkAdsUpload.value.startDate === null || vkAdsUpload.value.endDate == null) {
            isVKDataInputRight.value = false
            return
        }

        const start = getDate(vkAdsUpload.value.startDate)
        const end = getDate(vkAdsUpload.value.endDate)

        if (start === null || end === null) {
            isVKDataInputRight.value = false
            return
        }
        if (end < start) {
            isVKDataInputRight.value = false
            return
        }

        isVKDataInputRight.value = true;
    })

    return {
        selectedVKAccount,
        vkAdsUpload,
        isVKDataInputRight,
        setVKUpload,
        setVKAccount,
    }
}